/**
 * Flight Status – UI-only implementation.
 * Referenced from FIS project (Flights-UI): FlightStatusHeader, FlightStatusDetail.
 * API integration to be added later.
 */

export { default as FlightStatusHeader } from "./FlightStatusHeader/FlightStatusHeader";
export { default as FlightStatusHeaderPWA } from "./FlightStatusHeader/FlightStatusHeaderPWA";
export { default as FlightStatusDetail } from "./FlightStatusDetail/FlightStatusDetail";
export { FLIGHT_SEARCH_TYPE_OPTIONS, FLIGHT_STATUS_CARD_TYPES } from "./constants";
